const RUTAS = {
    PANEL: 'admin',
    ADMIN_MASTER: 'admin-master',
    USUARIOS: 'usuarios',
    GRUPOS: 'grupos',
    ETAPAS: 'etapas',
    PERFILES: 'perfiles',
    SECTORES_COMERCIALES: 'sectores-comerciales',
    EVENTOS: 'eventos',
    UNIDADES_NEGOCIO: 'unidades-negocio',
    REPORTES: 'reportes',
    REPORTE_DETALLE_SISTEMA_GRUPO: 'reportes/detalle-sistema-grupo',
    REPORTE_SEGURIDAD_WORKFLOW: 'reportes/seguridad-workflow',
    CLIENTE_TIPO: 'cliente-tipo',
    CLIENTE_TIPO_RELACIONES: 'cliente-tipo/relaciones',
    CLIENTE_TIPO_LCTC: 'cliente-tipo-lctc',
    CLIENTE_TIPO_LCTC_RELACIONES: 'cliente-tipo-lctc/relaciones',
    INSTRUMENTOS_LCSLHPTI: 'instrumentos-lcslhpti',
    SECTOR_SISTEMA_GRUPO: 'sector-sistema-grupo',
    ETAPA_ENVIO_MAIL: 'etapa-envio-mail',
    OBJETOS_SEGURIDAD: 'objetos-seguridad',
    PERMISOS: 'permisos',
    ETAPA_GRUPO_PERMISO: 'etapa-grupo-permiso',
    WF_INICIO_FIRMA: 'wf-inicio-firma',
    REIMPRESION: 'reimpresion'
} as const

export default RUTAS
